"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewerDetails = void 0;
var react_1 = __importDefault(require("react"));
var inversify_react_1 = require("inversify-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var ViewerAvatar_1 = require("../Components/ViewerAvatar");
var styles = __importStar(require("./SessionView.css"));
var SessionInfoLine_1 = require("../Components/SessionInfoLine");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var Utils_1 = require("../Utils");
var SharePopover_1 = require("Project/SharePopover/SharePopover");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var UpgradeButton_1 = require("Common/Upgrade/UpgradeButton");
var ViewerDetails = function (_a) {
    var viewer = _a.viewer, isAdmin = _a.isAdmin, isPageEditable = _a.isPageEditable, renderSharePopover = _a.renderSharePopover, closeModal = _a.closeModal;
    var isAnonymous = viewer.isAnonymous;
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var usingIdentityMapping = usingFeature(FeatureFlag_1.default.IdentityMapping);
    return (react_1.default.createElement(kaleidoscope_1.Card, null,
        react_1.default.createElement(kaleidoscope_1.Stack, { padding: "l", align: "start", gap: "l" },
            react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.viewerDetailsHeader, direction: "horizontal", justify: "spaceBetween", align: "center" },
                react_1.default.createElement(kaleidoscope_1.Heading, { level: "4", strong: true }, "Viewer details"),
                isAnonymous &&
                    (usingIdentityMapping
                        ? renderAccessAuthButton(isPageEditable, renderSharePopover)
                        : renderUpsellButton(isAdmin, closeModal))),
            react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.viewerAvatarAndName, direction: "horizontal", align: "center", gap: "m" },
                react_1.default.createElement(ViewerAvatar_1.ViewerAvatar, { viewer: viewer }),
                react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "xl" },
                    viewer.firstName,
                    viewer.lastName ? " ".concat(viewer.lastName) : "")),
            isAnonymous ? (renderAnonymousExplainer(usingIdentityMapping)) : (react_1.default.createElement(SessionInfoLine_1.SessionInfoList, null,
                react_1.default.createElement(SessionInfoLine_1.SessionInfoLine, { title: "Email address", IconType: icons_1.Mail, info: viewer.email }),
                react_1.default.createElement(SessionInfoLine_1.SessionInfoLine, { title: "Total view duration", IconType: icons_1.Preview, info: (0, Utils_1.formatCompactViewDuration)(viewer.totalViewDuration) }))))));
};
exports.ViewerDetails = ViewerDetails;
function renderAnonymousExplainer(usingIdentityMapping) {
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "m", align: "start" },
        react_1.default.createElement(kaleidoscope_1.Text, { size: "s", align: "left" },
            "This viewer is anonymous because they haven\u2019t been authenticated.",
            usingIdentityMapping
                ? " Enable access authentication to require future viewers to identify themselves before viewing the page."
                : " Upgrade to require future viewers to identify themselves before viewing the page."),
        react_1.default.createElement(kaleidoscope_1.Link, { href: "https://help.qwilr.com/article/154-can-i-see-who-viewed-my-projects" }, "Learn more about identity and authentication")));
}
function renderAccessAuthButton(isPageEditable, renderSharePopover) {
    if (!isPageEditable)
        return null;
    return (react_1.default.createElement(kaleidoscope_1.Popover, { size: kaleidoscope_1.PopoverSize.Auto, position: kaleidoscope_1.PopoverPosition.Bottom, offset: 12, button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.Button, __assign({}, buttonProps, { type: kaleidoscope_1.ButtonType.Secondary }), "Enable access authentication")); }, autoStack: true }, renderSharePopover(SharePopover_1.Menu.Access)));
}
function renderUpsellButton(isAdmin, closeModal) {
    if (isAdmin) {
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(UpgradeButton_1.UpgradeButton, { telemetryOrigin: "page_analytics_session_view_upgrade_button", onClick: closeModal })));
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
}
